import $ from 'jquery';
import html2canvas from 'html2canvas';

import { postDataBlob, postData } from './helper';

export const getData = async () => {
    let result = null;
    await $.get("/mantra.json", function (data) {
        result = data;
    });
    return result;
}

export const getObjectDetails = async ({ id, type }) => {
    let result = await getData();
    let details = result[type][id];
    // console.log("get details", details);
    return details;
}

export const firstLetterCaps = (s) => {
    if (typeof s !== 'string') return '';
    s = s.toLowerCase();
    return s.charAt(0).toUpperCase() + s.slice(1)
}

function getCanvasBlob(canvas) {
    return new Promise(function (resolve, reject) {
        canvas.toBlob(function (blob) {
            resolve(blob)
        }, 'image/jpeg')
    })
}


export const Html2CanvasFunction = async (reqData, done) => {
    let type = reqData.type;
    let croppedImageOutput = reqData.croppedImageOutput ? reqData.croppedImageOutput : '';
    window.scrollTo(0, 0);
    let module_name = reqData.module_name;
    let canvas = await html2canvas(document.querySelector("#canvas_generate_" + module_name), { "width": 1000, scale: 1 })
    var params = {};
    var blob = await getCanvasBlob(canvas);

    // (async function (blob) {

    //steps further
    //1. Start a loader here
    //2. Upload the image of this id uploaded above, canvas will reset above automatically
    console.log(blob);
    if (reqData.fullName) {

        params['fullName'] = reqData.fullName;
    }

    params['isblob'] = true;

    params['cardimage'] = blob;
    params['module_type'] = type //module_type
    params['module_subtype'] = module_name //sub module
    console.log(params, 'para');

    var post = await postDataBlob(params, 'postdata');
    post.addEventListener("load", function (data) {
        data = JSON.parse(post.response);
        if (data.data) {
            processShare(data.data, params, croppedImageOutput);
        }


    });
    return post;
}

export const processShare = async (data, params, croppedImageOutput) => {
    // data = JSON.parse(data);
    // if (data.message == "Success") {
    var imageUrl = data.cardimage;
    var id = data.id;
    // ref.setState({
    //     "shareData": imageUrl,
    //     "id": id,
    // });
    //                            update useruploaded image
    $(".preloader_mantra").hide();
    var params2 = params;
    params2['id'] = id
    params2['post_id'] = id;
    params2['cardimage'] = imageUrl;
    params2['ew_v'] = 2;
    console.log("sdf", params2);
    // return false;

    //make entry in database
    // postData(params2, 'savedata', "noloader").done((datas) => {
    var savedata = await postData(params2, 'savedata', "noloader")
    // .done((datas) => {
    //     console.log(data, 'datadata')


    //save original image
    // if (params2.module_type == 'upload' && croppedImageOutput) {
    //     params2['original_image'] = croppedImageOutput;
    //     postData(params2, 'uploadoriginalimage', "noloader").done((datas) => {
    //         console.log(datas);
    //     });
    // }

    // });
    return savedata;


    // }
}